import { Link, useLocation } from "react-router-dom";
import { HIDE_AND_SEEK_PATH, PRACTICE_PATH } from "../../../../constants";
import "./HideAndSeekPage.css";
import "./TutorialPage.css";

export default function TutorialPage() {
  const location = useLocation();
  const unit = location.state.unit;
  const category = location.state.category;

  return (
    <div className="hide-seek-page hide-seek-tutorial-page">
      <div className="hide-seek-tutorial-card">
        <h1>Hide and Seek Tutorial</h1>
        <p className="hide-seek-tutorial-subtitle">
          Learn the rules before starting the round.
        </p>

        <section className="hide-seek-tutorial-section">
          <h2>Goal</h2>
          <p>
            Listen to the audio prompt, then find the Korean letters that spell
            the word you hear.
          </p>
        </section>

        <section className="hide-seek-tutorial-section">
          <h2>How To Play</h2>
          <ul className="hide-seek-tutorial-list">
            <li>Move your mouse or finger to point the flashlight.</li>
            <li>Only letters inside the flashlight can be selected.</li>
            <li>Use the replay button whenever you need to hear the prompt again.</li>
            <li>Click the correct Korean letters to reveal the answer slots.</li>
            <li>Clicking the wrong letter costs one life.</li>
            <li>Finish the word before the timer reaches zero.</li>
          </ul>
        </section>

        <section className="hide-seek-tutorial-section">
          <h2>Difficulty</h2>
          <ul className="hide-seek-tutorial-list">
            <li>Easy gives you 60 seconds.</li>
            <li>Medium gives you 45 seconds.</li>
            <li>Hard gives you 30 seconds.</li>
          </ul>
        </section>

        <section className="hide-seek-tutorial-section">
          <h2>Hard Mode Guard</h2>
          <ul className="hide-seek-tutorial-list">
            <li>A guard appears only in hard mode.</li>
            <li>The guard changes position every 10 seconds.</li>
            <li>If your cursor stays on the guard for too long, you lose a life.</li>
          </ul>
        </section>

        <section className="hide-seek-tutorial-section">
          <h2>End Conditions</h2>
          <ul className="hide-seek-tutorial-list">
            <li>You keep going to the next word when you solve the current one.</li>
            <li>The round ends if you run out of time or lives.</li>
          </ul>
        </section>

        <div className="hide-seek-tutorial-actions">
          {unit ? (
            <Link to={HIDE_AND_SEEK_PATH} state={{ unit: unit, category: category }}>
              <button type="button" className="btn btn-primary">
                Back to Setup
              </button>
            </Link>
          ) : (
            <Link to={PRACTICE_PATH}>
              <button type="button" className="btn btn-back">
                Back to Textbook Selection
              </button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
